import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {InkomstTableItem} from '../shared/models/inkomst-table-item.model';

@Injectable({
  providedIn: 'root'
})
export class SammanstallningStoreService {
  private readonly _inkomstTableItems: BehaviorSubject<InkomstTableItem[]> = new BehaviorSubject<InkomstTableItem[]>([]);
  public readonly $inkomstTableItems: Observable<InkomstTableItem[]> = this._inkomstTableItems.asObservable();

  get inkomstTableItems(): InkomstTableItem[] {
    return this._inkomstTableItems.getValue();
  }

  set inkomstTableItems(val: InkomstTableItem[]) {
    this._inkomstTableItems.next(val);
  }

  addItem(item: InkomstTableItem): void {
    this.inkomstTableItems = [
      ...this.inkomstTableItems,
      item
    ];
  }

  updateItem(item: InkomstTableItem): void {
    const tableItem = this.inkomstTableItems.find(ti => ti.id === item.id);
    if (tableItem) {
      const index = this.inkomstTableItems.indexOf(tableItem);
      this.inkomstTableItems[index] = {
        ...tableItem,
        beloppUtbetald: item.beloppUtbetald,
        datum: item.datum,
        land: item.land,
        inkomsttyp: item.inkomsttyp,
        skatt: item.skatt,
        utlandskSkatt: item.utlandskSkatt,
        valuta: item.valuta
      };
      this.inkomstTableItems = [...this.inkomstTableItems];
    }
  }

  removeItem(id): void {
    this.inkomstTableItems =
      this.inkomstTableItems.filter(tableItem => tableItem.id !== id);
  }

  setSelected(id: number, isSelected: boolean): void {
    const tableItem = this.inkomstTableItems.find(ti => ti.id === id);
    if (tableItem) {
      const index = this.inkomstTableItems.indexOf(tableItem);
      this.inkomstTableItems[index] = {
        ...tableItem,
        isSelected
      };
      this.inkomstTableItems = [...this.inkomstTableItems];
    }
  }

  deselectCurrentItem() {
    const tableItem = this.inkomstTableItems.find(ti => ti.isSelected === true);
    if (tableItem) {
      const index = this.inkomstTableItems.indexOf(tableItem);
      this.inkomstTableItems[index] = {
        ...tableItem,
        isSelected: false
      };
      this.inkomstTableItems = [...this.inkomstTableItems];
    }
  }

  clearList() {
    this.inkomstTableItems = [];
  }
}
